var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
export var getTubeGql = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query {\n    tube @rest(type: \"TubeDetails\", path: \"/tube\", endpoint: \"query\") {\n      id\n      pathId\n      thumbnailOverlay\n      thumbnailLogo\n      backgroundImage\n      logo\n      color\n      name\n    }\n  }\n"], ["\n  query {\n    tube @rest(type: \"TubeDetails\", path: \"/tube\", endpoint: \"query\") {\n      id\n      pathId\n      thumbnailOverlay\n      thumbnailLogo\n      backgroundImage\n      logo\n      color\n      name\n    }\n  }\n"])));
export var getTubeData = function () {
    return graphql(getTubeGql, {
        options: {},
        props: function (_a) {
            var data = _a.data;
            return ({
                getTubeQuery: data,
            });
        },
    });
};
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/gql/queries/getTube.ts
// module id = 351
// module chunks = 81